/**
 * Generated by orval v8.7.0 🍺
 * Do not edit manually.
 * Agentiq.Api | v1
 * OpenAPI spec version: 1.0.0
 */
import {
  useQuery
} from '@tanstack/react-query';
import type {
  DataTag,
  DefinedInitialDataOptions,
  DefinedUseQueryResult,
  QueryClient,
  QueryFunction,
  QueryKey,
  UndefinedInitialDataOptions,
  UseQueryOptions,
  UseQueryResult
} from '@tanstack/react-query';

import type {
  GetApiLiveSnapshot200One,
  GetApiLiveSnapshot200Three,
  GetApiLiveSnapshot200Two
} from '../control-api.schemas';

import { orvalControlFetch } from '../../orval-fetcher';


type SecondParameter<T extends (...args: never) => unknown> = Parameters<T>[1];



export const getGetApiStateUrl = () => {




  return `/api/state`
}

export const getApiState = async ( options?: RequestInit): Promise<void> => {

  return orvalControlFetch<void>(getGetApiStateUrl(),
  {
    ...options,
    method: 'GET'


  }
);}





export const getGetApiStateQueryKey = () => {
    return [
    `/api/state`
    ] as const;
    }


export const getGetApiStateQueryOptions = <TData = Awaited<ReturnType<typeof getApiState>>, TError = unknown>( options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiState>>, TError, TData>>, request?: SecondParameter<typeof orvalControlFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetApiStateQueryKey();



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getApiState>>> = ({ signal }) => getApiState({ signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getApiState>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetApiStateQueryResult = NonNullable<Awaited<ReturnType<typeof getApiState>>>
export type GetApiStateQueryError = unknown


export function useGetApiState<TData = Awaited<ReturnType<typeof getApiState>>, TError = unknown>(
  options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiState>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getApiState>>,
          TError,
          Awaited<ReturnType<typeof getApiState>>
        > , 'initialData'
      >, request?: SecondParameter<typeof orvalControlFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetApiState<TData = Awaited<ReturnType<typeof getApiState>>, TError = unknown>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiState>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getApiState>>,
          TError,
          Awaited<ReturnType<typeof getApiState>>
        > , 'initialData'
      >, request?: SecondParameter<typeof orvalControlFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetApiState<TData = Awaited<ReturnType<typeof getApiState>>, TError = unknown>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiState>>, TError, TData>>, request?: SecondParameter<typeof orvalControlFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useGetApiState<TData = Awaited<ReturnType<typeof getApiState>>, TError = unknown>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiState>>, TError, TData>>, request?: SecondParameter<typeof orvalControlFetch>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetApiStateQueryOptions(options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return { ...query, queryKey: queryOptions.queryKey };
}






export const getGetApiStateFullUrl = () => {




  return `/api/state/full`
}

export const getApiStateFull = async ( options?: RequestInit): Promise<void> => {

  return orvalControlFetch<void>(getGetApiStateFullUrl(),
  {
    ...options,
    method: 'GET'


  }
);}





export const getGetApiStateFullQueryKey = () => {
    return [
    `/api/state/full`
    ] as const;
    }


export const getGetApiStateFullQueryOptions = <TData = Awaited<ReturnType<typeof getApiStateFull>>, TError = unknown>( options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiStateFull>>, TError, TData>>, request?: SecondParameter<typeof orvalControlFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetApiStateFullQueryKey();



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getApiStateFull>>> = ({ signal }) => getApiStateFull({ signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getApiStateFull>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetApiStateFullQueryResult = NonNullable<Awaited<ReturnType<typeof getApiStateFull>>>
export type GetApiStateFullQueryError = unknown


export function useGetApiStateFull<TData = Awaited<ReturnType<typeof getApiStateFull>>, TError = unknown>(
  options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiStateFull>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getApiStateFull>>,
          TError,
          Awaited<ReturnType<typeof getApiStateFull>>
        > , 'initialData'
      >, request?: SecondParameter<typeof orvalControlFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetApiStateFull<TData = Awaited<ReturnType<typeof getApiStateFull>>, TError = unknown>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiStateFull>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getApiStateFull>>,
          TError,
          Awaited<ReturnType<typeof getApiStateFull>>
        > , 'initialData'
      >, request?: SecondParameter<typeof orvalControlFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetApiStateFull<TData = Awaited<ReturnType<typeof getApiStateFull>>, TError = unknown>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiStateFull>>, TError, TData>>, request?: SecondParameter<typeof orvalControlFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useGetApiStateFull<TData = Awaited<ReturnType<typeof getApiStateFull>>, TError = unknown>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiStateFull>>, TError, TData>>, request?: SecondParameter<typeof orvalControlFetch>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetApiStateFullQueryOptions(options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return { ...query, queryKey: queryOptions.queryKey };
}






export const getGetApiLiveSnapshotUrl = () => {




  return `/api/live-snapshot`
}

export const getApiLiveSnapshot = async ( options?: RequestInit): Promise<GetApiLiveSnapshot200One | GetApiLiveSnapshot200Two | GetApiLiveSnapshot200Three> => {

  return orvalControlFetch<GetApiLiveSnapshot200One | GetApiLiveSnapshot200Two | GetApiLiveSnapshot200Three>(getGetApiLiveSnapshotUrl(),
  {
    ...options,
    method: 'GET'


  }
);}





export const getGetApiLiveSnapshotQueryKey = () => {
    return [
    `/api/live-snapshot`
    ] as const;
    }


export const getGetApiLiveSnapshotQueryOptions = <TData = Awaited<ReturnType<typeof getApiLiveSnapshot>>, TError = unknown>( options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiLiveSnapshot>>, TError, TData>>, request?: SecondParameter<typeof orvalControlFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetApiLiveSnapshotQueryKey();



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getApiLiveSnapshot>>> = ({ signal }) => getApiLiveSnapshot({ signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getApiLiveSnapshot>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetApiLiveSnapshotQueryResult = NonNullable<Awaited<ReturnType<typeof getApiLiveSnapshot>>>
export type GetApiLiveSnapshotQueryError = unknown


export function useGetApiLiveSnapshot<TData = Awaited<ReturnType<typeof getApiLiveSnapshot>>, TError = unknown>(
  options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiLiveSnapshot>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getApiLiveSnapshot>>,
          TError,
          Awaited<ReturnType<typeof getApiLiveSnapshot>>
        > , 'initialData'
      >, request?: SecondParameter<typeof orvalControlFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetApiLiveSnapshot<TData = Awaited<ReturnType<typeof getApiLiveSnapshot>>, TError = unknown>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiLiveSnapshot>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getApiLiveSnapshot>>,
          TError,
          Awaited<ReturnType<typeof getApiLiveSnapshot>>
        > , 'initialData'
      >, request?: SecondParameter<typeof orvalControlFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetApiLiveSnapshot<TData = Awaited<ReturnType<typeof getApiLiveSnapshot>>, TError = unknown>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiLiveSnapshot>>, TError, TData>>, request?: SecondParameter<typeof orvalControlFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useGetApiLiveSnapshot<TData = Awaited<ReturnType<typeof getApiLiveSnapshot>>, TError = unknown>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiLiveSnapshot>>, TError, TData>>, request?: SecondParameter<typeof orvalControlFetch>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetApiLiveSnapshotQueryOptions(options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return { ...query, queryKey: queryOptions.queryKey };
}






